import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {OptionsComponent} from './options.component';
import {DonationMenuComponent} from "./donation-menu/donation-menu.component";
import {DonationKakaopayComponent} from "./donation-kakaopay/donation-kakaopay.component";

const childRoutes: Routes = [
  {
    path: '',
    redirectTo: 'menu',
    pathMatch: 'full',
  },
  {
    path: 'menu',
    component: DonationMenuComponent,
  },
  {
    path: 'kakaopay',
    component: DonationKakaopayComponent,
  },
];

const routes: Routes = [
  {
    path: 'options',
    component: OptionsComponent,
    children: childRoutes,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class OptionsRoutingModule {
}
